import _ from 'lodash';
import {routes, url} from 'oo-routes';

import {VALID_EMAIL_REGEX} from './constants';

export function getStartedLink(user) {
  if (user) {
    if (user.shopify || user.wooCommerce) {
      return url('ecommerce', routes.ecommerce.dashboard.base);
    }
    return url('manager', routes.manager.base);
  } else {
    return url('website', routes.website2.home.catalog);
  }
}

export function validateUserRegistration(form) {
  const errors = {};
  if (!form.email || !VALID_EMAIL_REGEX.test(form.email)) {
    errors.email = 'Email address is invalid';
  }
  if (!form.first_name) {
    errors.first_name = 'Please provide first name';
  }
  if (!form.last_name) {
    errors.last_name = 'Please provide last name';
  }
  if (!form.password || form.password.length < 7) {
    errors.password = 'Password must be at least 7 characters in length';
  }
  if (!form.password === form.confirm) {
    errors.confirm = 'Password and re-typed password do not match';
  }
  if (!form.phone) {
    errors.phone = 'Please provide phone number';
  }

  return errors;
}



// WEBPACK FOOTER //
// ./app/util/index.js